import { parse } from 'hub-http/helpers/params';
export const getGateOverrides = search => {
  const {
    gated,
    ungated
  } = parse(search.substring(1));
  const overrides = {};
  if (ungated) {
    (Array.isArray(ungated) ? ungated : [ungated]).reduce((acc, gate) => {
      if (gate) acc[gate] = true;
      return acc;
    }, overrides);
  }
  if (gated) {
    (Array.isArray(gated) ? gated : [gated]).reduce((acc, gate) => {
      if (gate) acc[gate] = false;
      return acc;
    }, overrides);
  }
  return overrides;
};
export const withGateOverride = (gate, defaultValue, overrides = getGateOverrides(window.location.search)) => {
  const override = overrides[gate];
  return override !== undefined ? override : defaultValue;
};